module.exports = __webpack_public_path__ + "img/1919.cc00bb27.jpeg";